import axios from 'axios'
import {IUsuarioNuevo} from "./registro_user"

export default class Registro {

    public async Crear_Usuario_pub(user_nuevo:IUsuarioNuevo): Promise<string[] | undefined> {
        try {
            const api = process.env.VUE_APP_USER + 'CreatePublicUserByUser'; 
             const config = {
                headers:{ 
                 Content: 'application/json',          
                responseType: "json"               
                }
            };                      
            const result = await  axios.post( api , user_nuevo, config);
            return result.data; 
        } catch (error) {
            console.error('Error al crear el usuario: ', error);
            throw error;
        }
    }
   
    public async activacion_cuenta_user(user_id:string, _code:string): Promise <any | undefined>{
        try {
            const api = process.env.VUE_APP_USER + 'ConfirmEmailPublicUser'; 
            const config = {
                params:{
                    userId:user_id,
                    code:_code
                },
                headers:{
                Content: 'application/json',
                responseType: "json"
                }
            };        
            const result = await  axios.get(api,config);
            return result.data; 

        } catch (error) {
            console.error('Error en la activación de cuenta de  usuario: ', error);
            throw error;
        }   
    } 

    public async getCatSubsector(user_id:string, _code:string): Promise<string[] | undefined> {
        try {
           
            const api = process.env.VUE_APP_CATALOGOS + 'SectorUsuarioPublico'; 
            const config = {
                params:{
                    userId:user_id,
                    code:_code
                },
                headers:{
                Content: 'application/json',
                responseType: "json"
                }
            };        
            const result = await  axios.get(api,config);
            return result.data; 

        } catch (error) {
            console.error('Error en la activación de cuenta de  usuario: ', error);
            throw error;
        }   
    } 
   

}

